document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] [name="q"]`);
  if (inputSearch) {
    let debounceTimer;
    inputSearch.addEventListener("input", (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, true);
      }, 700);
    });
  }
});

const cartDrawer = document.querySelector("cart-drawer");

if (cartDrawer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "open") {
        if (cartDrawer.hasAttribute("open")) {
          BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
        }
      }
    }
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["open"],
  });
}

if (window.location.pathname.includes("/cart")) {
  document.addEventListener("done_check_ol_on_cart_page", () => {
    const customCheckout = document.querySelectorAll(".bss-checkout");
    const defaultBtnCheckout = document.querySelectorAll('button[name="checkout"]');
    if (customCheckout.length) {
       customCheckout.forEach(button => {
        button.removeAttribute("disabled");
      });
    }
    if (defaultBtnCheckout.length) {
       customCheckout.forEach(button => {
        button.removeAttribute("disabled");
      });
    }
  });

  setTimeout(() =>{
    const customCheckout = document.querySelectorAll(".bss-checkout");
    const defaultBtnCheckout = document.querySelectorAll('button[name="checkout"]');
    if (customCheckout.length) {
      customCheckout.forEach(button => {
        button.removeAttribute("disabled");
      });
    }
    if (defaultBtnCheckout.length) {
      customCheckout.forEach(button => {
        button.removeAttribute("disabled");
      });
    }
  }, 7000)
}



